import "@arco-design/web-react/es/Drawer/style";
import _Drawer from "@arco-design/web-react/es/Drawer";
import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import "@arco-design/web-react/es/Dropdown/style";
import _Dropdown from "@arco-design/web-react/es/Dropdown";
import _IconLoading from "@arco-design/web-react/icon/react-icon/IconLoading";
import _IconNotification from "@arco-design/web-react/icon/react-icon/IconNotification";
import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import _IconLanguage from "@arco-design/web-react/icon/react-icon/IconLanguage";
import _IconPoweroff from "@arco-design/web-react/icon/react-icon/IconPoweroff";
import "@arco-design/web-react/es/Divider/style";
import _Divider from "@arco-design/web-react/es/Divider";
import _IconLock from "@arco-design/web-react/icon/react-icon/IconLock";
import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import _IconSafe from "@arco-design/web-react/icon/react-icon/IconSafe";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { GlobalContext } from "@/context";
import useLocale from "@/utils/useLocale";
import Logo from "@/assets/logo.png";
import MessageBox from "@/components/MessageBox";
import IconButton from "./IconButton";
import styles from "./style/index.module.less";
import defaultLocale from "@/locale";
import useStorage from "@/utils/useStorage";
import CircleAvatar from "@/components/CircleAvatar";
import { updateAdminPassword } from "@/services/user/profile";

function Navbar({
  show
}) {
  const t = useLocale();
  const {
    userInfo,
    userLoading
  } = useSelector(state => state);
  const dispatch = useDispatch();
  const history = useHistory();
  const [, setUserStatus] = useStorage("userStatus");
  const [role] = useStorage("userRole", "admin");
  const [passwordDrawerVisible, setPasswordDrawerVisible] = useState(false);
  const [passwordSubmitting, setPasswordSubmitting] = useState(false);

  const [passwordForm] = _Form.useForm();

  const {
    setLang,
    lang
  } = useContext(GlobalContext);

  function logout() {
    setUserStatus("logout");
    window.location.href = "/login";
  }

  const openPasswordDrawer = () => {
    passwordForm.resetFields();
    setPasswordDrawerVisible(true);
  };

  const handlePasswordSubmit = async () => {
    try {
      const values = await passwordForm.validate();

      if (values.newPassword !== values.confirmPassword) {
        _Message.error("两次输入的密码不一致");

        return;
      }

      const username = userInfo?.username || userInfo?.accountId || userInfo?.name;

      if (!username) {
        _Message.error("无法获取当前账号信息，请重新登录后再试");

        return;
      }

      setPasswordSubmitting(true);
      const response = await updateAdminPassword({
        username,
        oldPassword: values.oldPassword,
        newPassword: values.newPassword
      });

      if (!response || response.code !== 200) {
        throw new Error(response?.message || "修改密码失败");
      }

      _Message.success("密码修改成功");

      setPasswordDrawerVisible(false);
      passwordForm.resetFields();
    } catch (error) {
      if (error?.errorFields) {
        return;
      }

      _Message.error(error?.message || error?.response?.data?.message || "修改密码失败");
    } finally {
      setPasswordSubmitting(false);
    }
  };

  function onMenuItemClick(key) {
    switch (key) {
      case "balance":
        history.push("/user/profile");
        break;

      case "password":
        openPasswordDrawer();
        break;

      case "logout":
        logout();
        break;

      default:
        break;
    }
  }

  useEffect(() => {
    if (process.env.REACT_APP_USE_MOCK !== "true") {
      return;
    }

    const authorities = role === "admin" ? ["sys:user:list", "sys:user:add", "sys:user:edit", "sys:user:delete", "sys:user:import", "sys:user:export", "sys:cdk:generate", "sys:cdk:unlink", "sys:cdk:delete", "sys:cdk:export"] : ["sys:user:list"];
    dispatch({
      type: "update-userInfo",
      payload: {
        userInfo: { ...userInfo,
          authorities
        }
      }
    });
  }, [role, dispatch, userInfo]);

  if (!show) {
    return null;
  }

  const droplist = /*#__PURE__*/React.createElement(_Menu, {
    onClickMenuItem: onMenuItemClick
  }, /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "balance"
  }, /*#__PURE__*/React.createElement(_IconSafe, {
    className: styles["dropdown-icon"]
  }), t["menu.user.balance"] || "用户余额"), /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "password"
  }, /*#__PURE__*/React.createElement(_IconLock, {
    className: styles["dropdown-icon"]
  }), t["navbar.changePassword"] || "修改密码"), /*#__PURE__*/React.createElement(_Divider, {
    style: {
      margin: "4px 0"
    }
  }), /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "logout"
  }, /*#__PURE__*/React.createElement(_IconPoweroff, {
    className: styles["dropdown-icon"]
  }), t["navbar.logout"]));
  return /*#__PURE__*/React.createElement("div", {
    className: styles.navbar
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, /*#__PURE__*/React.createElement("img", {
    src: Logo,
    alt: "logo",
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("div", {
    className: styles["logo-name"]
  }, "\u540E\u53F0\u7BA1\u7406\u7CFB\u7EDF"))), /*#__PURE__*/React.createElement("ul", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Select, {
    triggerElement: /*#__PURE__*/React.createElement(IconButton, {
      icon: /*#__PURE__*/React.createElement(_IconLanguage, null)
    }),
    options: [{
      label: "中文",
      value: "zh-CN"
    }, {
      label: "English",
      value: "en-US"
    }],
    value: lang,
    triggerProps: {
      autoAlignPopupWidth: false,
      autoAlignPopupMinWidth: true,
      position: "br"
    },
    trigger: "hover",
    onChange: value => {
      setLang(value);
      const nextLang = defaultLocale[value];

      _Message.info(`${nextLang["message.lang.tips"]}${value}`);
    }
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(MessageBox, null, /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(_IconNotification, null)
  }))), userInfo && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Dropdown, {
    droplist: droplist,
    position: "br",
    disabled: userLoading
  }, /*#__PURE__*/React.createElement(CircleAvatar, {
    size: 32,
    text: userInfo.name || userInfo.realname || userInfo.username || userInfo.accountId || "U",
    className: styles["navbar-avatar"]
  }, userLoading ? /*#__PURE__*/React.createElement(_IconLoading, null) : undefined)))), /*#__PURE__*/React.createElement(_Drawer, {
    title: "\u4FEE\u6539\u5BC6\u7801",
    width: 360,
    visible: passwordDrawerVisible,
    onCancel: () => {
      setPasswordDrawerVisible(false);
      passwordForm.resetFields();
    },
    footer: null,
    unmountOnExit: true,
    mountOnEnter: true
  }, /*#__PURE__*/React.createElement(_Form, {
    form: passwordForm,
    layout: "vertical",
    onSubmit: handlePasswordSubmit
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    label: "\u65E7\u5BC6\u7801",
    field: "oldPassword",
    rules: [{
      required: true,
      message: "请输入旧密码"
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    placeholder: "\u8BF7\u8F93\u5165\u65E7\u5BC6\u7801"
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    label: "\u65B0\u5BC6\u7801",
    field: "newPassword",
    rules: [{
      required: true,
      message: "请输入新密码"
    }, {
      minLength: 6,
      message: "密码至少 6 位字符"
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    placeholder: "\u8BF7\u8F93\u5165\u65B0\u5BC6\u7801"
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    label: "\u786E\u8BA4\u5BC6\u7801",
    field: "confirmPassword",
    rules: [{
      required: true,
      message: "请再次输入新密码"
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    placeholder: "\u8BF7\u518D\u6B21\u8F93\u5165\u65B0\u5BC6\u7801"
  })), /*#__PURE__*/React.createElement(_Space, {
    style: {
      marginTop: 12
    }
  }, /*#__PURE__*/React.createElement(_Button, {
    onClick: () => setPasswordDrawerVisible(false)
  }, "\u53D6\u6D88"), /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    loading: passwordSubmitting,
    onClick: handlePasswordSubmit
  }, "\u786E\u8BA4\u4FEE\u6539")))));
}

export default Navbar;